import { Eye, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTenant } from "@/hooks/useTenant";

export function ClientViewBanner() {
  const { families, familyId, setFamilyId, isMFO, isLoading } = useTenant();

  // Only show banner when MFO user has selected a specific family
  if (!isMFO || isLoading || !familyId) return null;

  const selectedFamily = families?.find((f) => f.id === familyId);
  if (!selectedFamily) return null;

  const handleExitClientView = () => {
    setFamilyId(null);
  };

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between gap-4 bg-amber-100 dark:bg-amber-900/50 border-b border-amber-200 dark:border-amber-800 px-4 py-2">
      <div className="flex items-center gap-2 text-amber-900 dark:text-amber-100">
        <Eye className="h-4 w-4" />
        <span className="text-sm font-medium">
          Viewing as: <span className="font-semibold">{selectedFamily.name}</span>
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleExitClientView}
        className="text-amber-900 dark:text-amber-100 hover:bg-amber-200 dark:hover:bg-amber-800"
      >
        <ArrowLeft className="h-4 w-4 mr-1" />
        Exit to Firm View
      </Button>
    </div>
  );
}
